// One name per creative placement tag, wherever a person reads one: the drawer's asset cards,
// the content editor's replacement slots and the versions timeline. There used to be three
// tables ("Square · 1:1", "Feed (1:1)" and the raw "META_SQ" tag) for the same crop.

const LABELS: Readonly<Record<string, string>> = {
  meta_sq: 'Square · 1:1',
  meta_fs: 'Portrait · 4:5',
  meta_story: 'Stories and Reels · 9:16',
  ctv_16x9: 'Video · 16:9',
};

/** A placement tag in words: `meta_sq` → "Square · 1:1", `dsp_300x250_2` → "Display 300×250". */
export function placementLabel(tag: string): string {
  const known = LABELS[tag];
  if (known) return known;
  const display = /^dsp_(\d+)x(\d+)(?:_\d+)?$/.exec(tag);
  if (display) return `Display ${display[1]}×${display[2]}`;
  return 'Other placement';
}
